const state = {
	requirements_index: {
		data: [],
		links: {},
		meta: {},
	},
};

export default state;
